// extracted by mini-css-extract-plugin
export default {"post_container":"Post_post_container__StM7A","tags":"Post_tags__+lPxk"};